module.exports = __webpack_public_path__ + "static/media/about-truss-2.dbb5ec95.png";